export const Goal = 'Goal';
export const OwnGoal = 'OwnGoal';
export const Substitution = 'Substitution';
export const YellowCard = 'YellowCard';
export const RedCard = 'RedCard';
export const Offside = 'Offside';
export const EndGame = 'EndGame';
export const TacticsChange = 'TacticsChange';
export const HalfTime = 'HalfTime';



/** WEBPACK FOOTER **
 ** ./src/components/Animations/Scenes/SceneTypes.js
 **/